import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import Text from 'core/elements/Text'
import AddNodeGroups from 'k8s/components/capacity-and-health/AddNodeGroups'
import FontAwesomeIcon from 'pf9-ui-components/built/components/FontAwesomeIcon'
import Theme from 'pf9-ui-components/built/theme-manager/themes/model'
import React, { useEffect, useMemo, useState } from 'react'

interface NodePoolConfigCardProps {
  nodePool: any
  vmFlavors: any[]
  storagePools: any[]
  networks: any[]
  onChange: (value: Record<string, any>) => void
  onDeleteNodePool: (id: number) => void
  showDeleteButton?: boolean
  errors?: Errors
  loadingVmFlavors?: boolean
}

interface Errors {
  [fieldId: string]: string
}

export default function NodePoolConfigCard({
  nodePool,
  onChange,
  vmFlavors,
  storagePools,
  networks,
  showDeleteButton = false,
  onDeleteNodePool,
  errors = undefined,
  loadingVmFlavors = false,
}: NodePoolConfigCardProps) {
  const [collapseCard, setCollapseCard] = useState(false)
  const classes = useStyles()

  return (
    <div className={classes.nodePoolContainer}>
      <div
        className={clsx(
          classes.header,
          collapseCard ? classes.headerCollapsed : classes.headerExpanded,
        )}
        onClick={() => setCollapseCard(!collapseCard)}
      >
        <Text variant="subtitle2">{`#${nodePool?.id} Node Group`}</Text>
        <FontAwesomeIcon
          solid
          size="xs"
          className={clsx(
            classes.toggleIcon,
            collapseCard ? classes.toggleIconCollapsed : classes.toggleIconExpanded,
          )}
        >
          chevron-up
        </FontAwesomeIcon>
      </div>
      {!collapseCard && (
        <div className={classes.content}>
          <AddNodeGroups
            nodePool={nodePool}
            onChange={onChange}
            vmFlavors={vmFlavors}
            storagePools={storagePools}
            networks={networks}
            showDeleteButton={showDeleteButton}
            onDeleteNodePool={onDeleteNodePool}
            errors={errors}
            loadingVmFlavors={loadingVmFlavors}
          />
        </div>
      )}
    </div>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  nodePoolContainer: {
    display: 'grid',
    border: `1px solid ${theme.components.card.border}`,
    borderRadius: '4px',
    marginBottom: theme.spacing(2),
    '& .accordionTopBar': {
      height: '48px',
    },
  },
  header: {
    borderTop: `1px solid  ${theme.components.accordion.border}`,
    color: `${theme?.components?.typography?.default}`,
    cursor: 'pointer',
    padding: '0 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: 'none',
    transition: 'background-color 0.6s ease',
    height: '48px',
  },
  headerCollapsed: {
    backgroundColor: theme.components.accordion.background,
  },
  headerExpanded: {
    backgroundColor: theme.components.accordion.activeBackground,
  },
  toggleIcon: {
    transition: 'transform 0.2s ease',
  },
  toggleIconCollapsed: {
    transform: 'rotate(180deg)',
  },
  toggleIconExpanded: {
    transform: 'rotate(0deg)',
  },
  content: {
    margin: theme.spacing(2, 3, 3),
  },
}))
